import React from 'react';
import { useAtom } from 'jotai';
import { useTranslation } from 'react-i18next';
import { ModalDelete } from './modal-delete';
import { ModalCustom } from './ModalCustom';
import { ModalConfirm } from './modal-confirm';
import { ModalFinish } from './modal-finish';
import { SubModal } from './SubModal';
import { globalModalState } from '@esg/framework';

export const ModalGlobal = () => {
    const [modalState, setModalState] = useAtom(globalModalState);
    const [isLoading, setIsLoading] = React.useState(false);

    const resetModalState = () => setModalState(globalModalState.init);
    const { t } = useTranslation();

    const onCancel = React.useCallback(() => {
        modalState?.onCancel?.();
        resetModalState();
    }, [modalState, resetModalState]);

    const onOk = React.useCallback(() => {
        if (!!modalState?.footer) {
            return modalState?.onOk?.();
        }
        setIsLoading(true);
        setTimeout(() => {
            Promise.resolve(modalState?.onOk?.())
                .finally(() => {
                    setIsLoading(false);
                });
        }, 800);

    }, [modalState?.onOk, modalState?.footer]);

    if (modalState?.showModalDelete) {
        return (
            <ModalDelete
                open={modalState?.isOpen}
                onOk={onOk}
                onCancel={onCancel}
                footer={modalState.footer}
                confirmLoading={isLoading}
            >
                {modalState?.content}
            </ModalDelete>
        );
    }

    if (modalState?.showModalConfirm) {
        return (
            <ModalConfirm
                open={modalState?.isOpen}
                onOk={onOk}
                onCancel={onCancel}
                footer={modalState.footer}
                confirmLoading={isLoading}
            >
                {modalState?.content}
            </ModalConfirm>
        );
    }

    if (modalState?.showModalFinish) {
        return (
            <ModalFinish
                open={modalState?.isOpen}
                onOk={onOk}
                onCancel={onCancel}
                footer={modalState.footer}
                confirmLoading={isLoading}
            >
                {modalState?.content}
            </ModalFinish>
        );
    }
    const titleModal = typeof modalState?.titleTransCode === 'string' ? t(modalState.titleTransCode) : modalState?.titleTransCode;
    return (
        <ModalCustom
            destroyOnClose
            open={modalState?.isOpen}
            closeIcon={modalState?.closeIcon}
            title={titleModal}
            onCancel={onCancel}
            cancelText={modalState?.cancelText}
            okText={modalState?.okText}
            footer={modalState?.footer}
            width={modalState?.width}
            onOk={modalState?.onOk}
            showDivider={modalState?.showDivider}
            maskClosable={modalState?.maskClosable}
            okButtonProps={{
                style: { backgroundColor: modalState?.backgroundColorBtn, borderColor: modalState?.backgroundColorBtn }
            }}
        >
            {modalState?.content}
            <SubModal />
        </ModalCustom>
    );
};
